// Angular
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

// Rxjs
import { Observable } from 'rxjs';

@Injectable()
export class ImageInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // // add authorization header with basic auth credentials if available
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // if (currentUser && currentUser.authdata) {
        //     request = request.clone({
        //         setHeaders: {
        //             Authorization: `Basic ${currentUser.authdata}`
        //         }
        //     });
        // }

        return next.handle(request);
    }
}